<template>
  <div class="">
    <page-header title="New Route" breadcrumb="Dashboard >> Settings >> Routes >> New Route" />
    <div class="mt-3 custom-card">

      <div class="route-type">
        <div>
          <p class="font-semibold">Route Type</p>
        </div>
        <div class="route-type-options">
      
          <div class="single-option">
            <label for="intra-state" class="radio-label label">
              <input type="radio" id="intra-state" value="intraState" v-model="routeType" />
              Intra State
              <span></span>
            </label>
          </div>
          
        </div>
      </div>

      <intra-state-form v-if="isIntrastate" :states="states" />
    </div>
  </div>
</template>

<script>
import IntraStateForm from "./partials/IntraStateForm.vue";

export default {
  components: {
    IntraStateForm,
  },
  data() {
    return {
      routeType: "intraState",
    };
  },
  mounted() {
    this.getAllStatesAndCities();
  },
  methods: {

    createRequestPayload() { },
  },
  computed: {
    isInterstate() {
      return this.routeType === "interState";
    },
    isIntrastate() {
      return this.routeType === "intraState";
    },
    international() {
      return this.routeType === "international";
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.route-type {
  display: flex;
  flex-wrap: wrap;

  p {
    padding-right: 2rem;
  }
}

.route-type-options {
  display: flex;
  flex-wrap: wrap;

  .single-option {
    padding-right: 1.5rem;
  }
}
</style>
